module.exports = __webpack_public_path__ + "img/t_2.f8cb7a42.jpg";